export default __webpack_public_path__ + "static/media/screenshot1.6b43e327.jpg";